/* eslint-disable react/no-array-index-key */
import IssueGrid from './IssueGrid';
import ModuleWrapper from './ModuleWrapper';
import Submodule from './Submodule';
import IssueTabs from './IssueTabs';

import type { ModuleDef } from '../types/modulesv2';
import { EditContextProvider } from '../context/EditContext';

interface IssueModuleProps<TData> {
  module: ModuleDef<TData>;
  issueId?: string | number;
  variant?: string;
}

const IssueModule = <TData extends unknown>({
  module: issueModule,
  issueId,
  variant,
}: IssueModuleProps<TData>) => {
  const { submodules, hide, ...moduleProps } = issueModule;

  if (!issueModule || !issueModule.submodules.length) return null;

  if (issueModule.layout === 'grid') {
    return (
      <IssueGrid
        title={issueModule.title}
        submodules={issueModule.submodules}
        noPrint={issueModule.noPrint}
        variant={variant}
      />
    );
  }

  if (issueModule.layout === 'tabs') {
    return <IssueTabs module={issueModule} />;
  }

  return (
    <ModuleWrapper {...moduleProps} issueId={issueId} variant={variant}>
      {issueModule.submodules.map((submodule, i) => (
        <EditContextProvider
          permissions={submodule.canEdit}
          key={`submodule-${i}-${submodule.title || issueModule.title || ''}`}
        >
          <Submodule submodule={submodule} />
        </EditContextProvider>
      ))}
    </ModuleWrapper>
  );
};

export default IssueModule;
